import type { OrganizationResource } from '@/types/organizations'

export function isDirectorEnabled(organization?: OrganizationResource | null): boolean {
  return (
    organization?.attributes.feature_flags?.director_enabled
    ?? organization?.attributes.director_enabled
    ?? false
  ) === true
}

export function canUseDirector(
  organization: OrganizationResource | null | undefined,
  authReady: boolean,
): boolean {
  return authReady && isDirectorEnabled(organization)
}
